import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-white" data-id="element-103" data-mp="hvz4dzzy5igi">
      {/* Slim brand bar */}
      <div className="border-b-[3px] border-naranja" data-id="element-104" data-mp="mutxburmonec">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-4 py-4 sm:px-6" data-id="element-105" data-mp="mrxz05bvbwpd">
          <span className="font-heading text-lg font-bold text-marino" data-id="element-106" data-mp="qtj61a1q1grn">Balonmano Pro 360</span>
        </div>
      </div>

      <div className="relative bg-gradient-to-b from-bg-secondary to-white pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-107" data-mp="10lfgzlowp1da">
        <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-108" data-mp="15ks3g5bv86fc">
          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-109" data-mp="1aj3egjdwcmz5">
            <SectionTag data-id="element-110" data-mp="9o2pxlktsqn2">Para entrenadores que quieren dejar de improvisar</SectionTag>
          </m.div>

          <m.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.1] tracking-tight text-marino sm:text-5xl md:text-6xl" data-id="element-111" data-mp="4ogar6lft0bm">
            Todo tu año de <span className="text-naranja" data-id="element-112" data-mp="sdsliawexgg1">Balonmano</span> resuelto.
          </m.h1>

          {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
          <img src="https://cdn.magicpatterns.com/uploads/hz4SXWefcoDFqs52JzGpFd/ChatGPT_Image_1_sept_2026__20_47_17-removebg-preview.png" alt="Balonmano Pro 360: El Sistema Completo — colección de 6 tomos y 5 bonos" width={480} height={480} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-xs sm:max-w-sm" data-id="element-113" data-mp="infq1nn282v4" />

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.18
        }} className="mt-6 font-heading text-lg font-semibold text-naranja sm:text-xl" data-id="element-114" data-mp="30o9uskx1ih8p">
            El Sistema "Sesión en Mano" — colección de 6 tomos y 5 bonos
          </m.p>

          <m.p initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-5 max-w-2xl border-l-4 border-naranja px-4 text-left text-base leading-relaxed text-gris-texto sm:text-lg" data-id="element-115" data-mp="2huedcawgvayd">
            Ten siempre una sesión lista para llevar al pabellón, aunque sea domingo a las 22:00 y todavía no
            hayas preparado nada. Balonmano Pro 360 reúne 6 tomos con sesiones reales listas{' '}
            <span className="font-semibold text-marino" data-id="element-116" data-mp="b3ophc6r0g50">"Sesión en Mano"</span> para que abras el PDF, veas
            el ejercicio y sepas exactamente qué hacer en tu próximo entrenamiento.
          </m.p>

          <m.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-7 flex flex-col items-center" data-id="element-117" data-mp="1qpii63xknfqg">
            <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-118" data-mp="20kagxb2w48mt">QUIERO BALONMANO PRO 360</PrimaryButton>
            <p className="mt-3 text-xs text-gris-muted sm:text-sm" data-id="element-119" data-mp="2abx0pvtang16">
              ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
            </p>
          </m.div>

          <m.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="mt-6 flex flex-col items-center gap-2 text-sm text-gris-muted sm:flex-row sm:gap-4" data-id="element-120" data-mp="2o9bqx2rdfru7">
            <div className="flex items-center gap-2" data-id="element-121" data-mp="p050b2fqmvy4">
              <StarRating data-id="element-122" data-mp="qg90e1vcvlts" />
              <span className="font-medium text-marino" data-id="element-123" data-mp="qexxe49qii3q">4,9/5</span>
              <span data-id="element-124" data-mp="veavxm9yxdm5">· +500 reseñas verificadas</span>
            </div>
            <div className="hidden h-4 w-px bg-gris-claro sm:block" aria-hidden="true" data-id="element-125" data-mp="vgnbjss97bw1" />
            <div className="flex items-center gap-1.5 text-naranja" data-id="element-126" data-mp="10bu9ejyudmd1">
              <FlameIcon size={16} className="fill-naranja" data-id="element-127" data-mp="15bp0oomj4dym" />
              <span data-id="element-128" data-mp="7phx9i1yornu">42 entrenadores eligieron Balonmano Pro 360 hoy</span>
            </div>
          </m.div>
        </div>
      </div>
    </header>;
}